/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Backdrop, Button, CircularProgress, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Controller, useForm } from 'react-hook-form';
import deLocale from "date-fns/locale/es";
import { styles } from "./styles";
import { defaultValues } from './models';
import * as yup from "yup";
import { getActiveRegionals } from '../../actions/regional-actions';
import { REQUIRED_MESSAGE } from '../../constants';
import { yupResolver } from '@hookform/resolvers/yup';
import { ColorButton } from "../../utils/form/buttonsForm";
import DateFnsUtils from "@date-io/date-fns";
import { saveRefundByRecomendationAsync } from '../../actions/refund-recommendation-actions';
import { withRouter } from 'react-router';


const RefundRecomendationsAtRegisterForm = (props) => {
  const { user, maestras, setMessage, message, setShowMessage, dispatch } = props;
  const _ = require("lodash");
  const classes = styles();
  const [regionales, setRegionales] = useState([]);
  const [minDate, setMinDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  var currentDate = new Date();
  currentDate.setMinutes(
    currentDate.getMinutes() + currentDate.getTimezoneOffset()
  );

  useEffect(() => {
    const getRegionales = async () => {
      const response = await getActiveRegionals();
      let orderRegionales = _.sortBy(
        response.data && response.data.regionalList,
        (o) => o.name
      );
      setRegionales(orderRegionales);
    };
    getRegionales();
  }, []);

  const schema = yup.object().shape({
    firstName: yup.string().nullable().notRequired(),
    secondName: yup.string().nullable().notRequired(),
    surname: yup.string().nullable().notRequired(),
    secondSurname: yup.string().nullable().notRequired(),
    regional: yup.string().nullable().notRequired(),
    gender: yup.string().nullable().notRequired(),
    initRefundDate: yup
      .date()
      .typeError("Fecha inválida")
      .nullable()
      .required(REQUIRED_MESSAGE),
    endRefundDate: yup
      .date()
      .typeError("Fecha inválida")
      .nullable()
      .notRequired(),
  });

  const { register, handleSubmit, setValue, control, errors } =
    useForm({
      resolver: yupResolver(schema),
      defaultValues,
      mode: "onChange",
      reValidateMode: "onChange",
    });

  const setPersonData = (user) => {
    const data = user.employee;
    setValue("firstName", data.firstName);
    setValue("secondName", data.secondName);
    setValue("surname", data.surname);
    setValue("secondSurname", data.secondSurname);
    setValue("regional", data?.regional?.id);
    setValue("gender", data?.gender);
  };

  useEffect(() => {
    if (user?.employee?.firstName) {
      setPersonData(user);
    };
  },[])


  const onSubmitFinalize = async (data) => {
    setIsLoading(true);
    const refundRecomendationObject = {
      initRefundDate: data.initRefundDate,
      endRefundDate: data.endRefundDate,
      employeeId: user?.employee?.id
    }

    const response = await saveRefundByRecomendationAsync(refundRecomendationObject, dispatch);
    setIsLoading(false);
    if (response && (response?.status === 200 || response?.status === 201)) {
      setShowMessage(true);
      setMessage({
        description: `El registro se ha guardado de forma exitosa.`,
        textButtonSubmit: "Volver",
        handleClick: () => closeModalRedirect(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      setShowMessage(true);
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : response?.data?.error
            ? response?.data?.error
            : `El registro no ha sido creado, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => closeModal(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setShowMessage(true);
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => closeModal(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const closeModal = () => {
    setShowMessage(false);
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const closeModalRedirect = () => {
    setShowMessage(false);
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
    props.history.push("/dashboard/refund-recomendation-search");
  };

  const redirect = () => {
    props.history.push("/dashboard/refund-recomendation-search");
  }

  const onSubmit = (data) => {
    setShowMessage(true);
    setMessage(() => ({
      open: true,
      description: "¿Está seguro que desea guardar este registro? ",
      type: "QUESTION",
      handleClick: () => onSubmitFinalize(data),
      handleClickOut: closeModal,
    }));
  };

  const handleMinDate = (value) => {
    setMinDate(value)
  }

  return (
    <React.Fragment>
      <form
        id="recomendationsAt"
        onSubmit={handleSubmit(onSubmit)}
        className={classes.form}
      >
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Primer nombre"
                name="firstName"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message
                }
                helperText={
                  errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Segundo nombre"
                name="secondName"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("secondName") &&
                  errors["secondName"].message
                }
                helperText={
                  errors.hasOwnProperty("secondName") &&
                  errors["secondName"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Primer apellido"
                name="surname"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("surname") &&
                  errors["surname"].message
                }
                helperText={
                  errors.hasOwnProperty("surname") && errors["surname"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Segundo apellido"
                name="secondSurname"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("secondSurname") &&
                  errors["secondSurname"].message
                }
                helperText={
                  errors.hasOwnProperty("secondSurname") &&
                  errors["secondSurname"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("regional") &&
                errors["regional"].message
              }
            >
              <InputLabel htmlFor="outlined-select-regional" shrink={true}>
                Regional *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Regional *"
                disabled={true}
                size="small"
                name="regional"
                style={{ backgroundColor: "#ffffff" }}
                notched={true}
                inputProps={{
                  name: "shoeSize",
                  id: "outlined-select-regional",
                }}
                as={
                  <Select>
                    {regionales.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        {op.name}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("regional") &&
                  errors["regional"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("gender") &&
                errors["gender"].message
              }
            >
              <InputLabel htmlFor="outlined-select-gender" shrink={true}>
                Genero *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Genero *"
                disabled={true}
                size="small"
                name="gender"
                style={{ backgroundColor: "#ffffff" }}
                notched={true}
                inputProps={{
                  name: "gender",
                  id: "outlined-select-gender",
                }}
                as={
                  <Select>
                    {maestras?.generos?.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.key}
                        value={op.key}
                      >
                        {op.value}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("gender") &&
                  errors["gender"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    InputProps={{ readOnly: true }}
                    style={{ backgroundColor: "#ffffff" }}
                    format="dd/MM/yyyy"
                    label="Fecha de inicio *"
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    onAccept={handleMinDate}
                    error={
                      !!errors.hasOwnProperty("initRefundDate") &&
                      errors["initRefundDate"].message
                    }
                    FormHelperTextProps={{
                      style: {
                        backgroundColor: "#e0f1f8",
                        width: "100%",
                        marginLeft: "0px",
                        marginTop: "0px",
                        paddingTop: "4px",
                      },
                    }}
                    helperText={
                      errors.hasOwnProperty("initRefundDate") &&
                      errors["initRefundDate"].message
                    }
                  />
                }
                control={control}
                name="initRefundDate"
                placeholder="Fecha de inicio *"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    InputProps={{ readOnly: true }}
                    style={{ backgroundColor: "#ffffff" }}
                    format="dd/MM/yyyy"
                    label="Fecha final"
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    error={
                      !!errors.hasOwnProperty("endRefundDate") &&
                      errors["endRefundDate"].message
                    }
                    FormHelperTextProps={{
                      style: {
                        backgroundColor: "#e0f1f8",
                        width: "100%",
                        marginLeft: "0px",
                        marginTop: "0px",
                        paddingTop: "4px",
                      },
                    }}
                    helperText={
                      errors.hasOwnProperty("endRefundDate") &&
                      errors["endRefundDate"].message
                    }
                    minDate={minDate}
                  />
                }
                control={control}
                name="endRefundDate"
                defaultValue={null}
                placeholder="Fecha final"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={12} lg={12} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              style={{
                backgroundColor: "transparent",
                color: "#7EBDCE",
                width: "100px",
                marginRight: "20px",
              }}
              onClick={redirect}
              variant="outlined"
            >
              CANCELAR
            </Button>
            <ColorButton
              style={{
                width: "100px",
                marginRight: "20px"
              }}
              type="submit"
              disabled={isLoading}
            >
              GUARDAR
            </ColorButton>
          </Grid>
        </Grid>
      </form>
      <Backdrop
        style={{ zIndex: "9999" }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default withRouter(RefundRecomendationsAtRegisterForm)